import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { createUnitFormatter } from './format';
import { unitsAtom } from './unitsAtom';

export function useUnitFormatter() {
  const units = useAtomValue(unitsAtom);
  return useMemo(() => createUnitFormatter(units), [units]);
}
